module.exports = __webpack_public_path__ + "static/img/widget-1.03d4157d.png";